import { Power1 } from 'gsap';
import * as PIXI from 'pixi.js';
import Preset from '../Preset';
import PieSlice from '../../graphics/PieSlice';
import Rectangle from '../../graphics/Rectangle';
import {
  getCenterX,
  getCenterY,
  getPadding,
} from '../../utils/CoordinateCalculator';

export default class Flex extends Preset {
  leftSlice = new PieSlice();
  rightSlice = new PieSlice();
  divider = new Rectangle();
  alphaFilter = new PIXI.filters.AlphaFilter(0);

  constructor(app) {
    super({ app, isFullScreen: true, requiresRootTransform: true });
  }

  update(model) {
    super.update(model);

    const { x, y, width, height } = this.root;
    const halfDuration = model.duration / 2;
    const thirdDuration = model.duration / 3;
    const sixthDuration = model.duration / 6;

    this.divider.color = this.primaryColor.clone();
    this.divider.alpha = 1;
    this.divider.width = getPadding(this.app.screen.height, 5);
    this.divider.height = 0;
    this.divider.y = getCenterY(this.divider, this.root);
    this.divider.x = getCenterX(this.divider, this.root);

    this.animate(this.divider)
      .to({
        y,
        height,
        duration: sixthDuration,
        ease: Power1.easeInOut,
      })
      .reverseOut();

    this.leftSlice.color = this.primaryColor.clone();
    this.leftSlice.alpha = 1;
    this.leftSlice.arcRadians = 0;
    this.leftSlice.clockwise = true;
    this.leftSlice.startRadians = (3 * Math.PI) / 2;
    this.leftSlice.root = {
      x,
      y,
      width: width / 2,
      height,
    };

    this.animate(this.leftSlice)
      .to(
        {
          arcRadians: Math.PI,
          duration: thirdDuration,
          ease: Power1.easeInOut,
        },
        sixthDuration
      )
      .reverseOut();

    this.rightSlice.color = this.primaryColor.clone();
    this.rightSlice.alpha = 1;
    this.rightSlice.arcRadians = 0;
    this.rightSlice.clockwise = true;
    this.rightSlice.startRadians = Math.PI / 2;
    this.rightSlice.root = {
      ...this.leftSlice.root,
      x: x + width / 2,
    };

    this.animate(this.rightSlice)
      .to(
        {
          arcRadians: Math.PI,
          duration: thirdDuration,
          ease: Power1.easeInOut,
        },
        sixthDuration
      )
      .reverseOut();

    this.graphics.filters = [this.alphaFilter];
    this.alphaFilter.alpha = 0;
    this.animate(this.alphaFilter)
      .to({
        alpha: this.primaryColor.getAlpha(),
        duration: halfDuration,
        ease: Power1.easeOut,
      })
      .reverseOut();
  }

  render() {
    super.render();
    this.leftSlice.draw(this.graphics);
    this.rightSlice.draw(this.graphics);
    this.divider.draw(this.graphics);
  }
}
